import { connect, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  CButton,
  CCol,
  CForm,
  CFormInput,
  CFormSelect,
  CInputGroup,
  CInputGroupText, CNav,
  CNavItem, CNavLink,
  CRow, CTabContent, CTabPane
} from "@coreui/react";
import { Loading } from "../../../components/common";
import { AgGridReact } from "ag-grid-react";
import * as o2Api from "../../../api/api";

const HandleProduct = () => {
  const { user } = useSelector((props) => props.account);
  const navigate = useNavigate();
  const gridRef = useRef();

  const [activeKey, setActiveKey] = useState(1);
  const [company, setCompany] = useState([{ cmpCd: "", cmpNm: "전체" }]);
  const [brand, setBrand] = useState([{ brandCd: "", brandNm: "전체" }]);
  const [store, setStore] = useState([{ storeCd: "", storeNm: "전체" }]);
  const [corner, setCorner] = useState([{ cornerCd: "", cornerNm: "전체" }]);
  const [selected, setSelected] = useState({
    cmpCd: "", brandCd: "", storeCd: "", cornerCd: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ visible: false, message: "" });
  const [rowData, setRowData] = useState([]);
  const [formData, setFormData] = useState({});

  const [columnDefs] = useState([
    {
      field: "isUse",
      headerName: "No",
      width: 120,
      headerCheckboxSelection: true,
      checkboxSelection: (params) => {
        return !params.data.isUse;
      },
      showDisabledCheckboxes: true,
      valueFormatter: (e) => {
        return e.data.isUse !== null ? "사용" : "미사용";
      }
    },
    { field: "restProductCd", headerName: "상품코드", width: 130 },
    { field: "productNm", headerName: "상품명" },
    { field: "sourceCd", headerName: "바코드", width: 200 },
    { field: "supPrice", headerName: "원가" },
    { field: "price", headerName: "판매단가" },
    { field: "productDiv", headerName: "상품구분", width: 100 },
    { field: "bagYn", headerName: "봉투사용여부" },
    { field: "bagPrice", headerName: "봉투금액", width: 100 }
  ]);

  useEffect(() => {
    getCompany();
  }, []);

  const getCompany = async () => {
    if (user.cmpCd !== null) {
      const { data: result } = await o2Api.getCompany(user.cmpCd);
      const { responseBody, responseCode, responseMessage } = result;
      if (responseCode === "200") {
        // 성공
        setCompany([responseBody]);
        setSelected((state) => ({
          ...state,
          cmpCd: user.cmpCd
        }));
        getBrand(user.cmpCd);
      }
    } else {
      const params = {
        userId: user.userId
      }

      const { data: result } = await o2Api.getCompanyList(params);
      const { responseBody, responseCode, responseMessage } = result;
      if (responseCode === "200") {
        // 성공
        setCompany([{ cmpCd: "", cmpNm: "전체" }]);
        setCompany((state) => state.concat(responseBody));
      }
    }
  };

  const getBrand = async (cmpCd) => {
    if (user.brandCd !== null) {
      const { data: result } = await o2Api.getBrand(user.cmpCd, user.brandCd);
      const { responseBody, responseCode, responseMessage } = result;
      if (responseCode === "200") {
        // 성공
        setBrand([responseBody]);
        setSelected((state) => ({
          ...state,
          brandCd: user.brandCd
        }));
        getStore(user.cmpCd, user.brandCd);
      }
    } else {
      const { data: result } = await o2Api.getBrandList(cmpCd);
      const { responseBody, responseCode, responseMessage } = result;
      if (responseCode === "200") {
        // 성공
        setBrand([{ brandCd: "", brandNm: "전체" }]);
        setBrand((state) => state.concat(responseBody));
      }
    }
  };

  const getStore = async (cmpCd, brandCd) => {
    const params = {
      cmpCd: cmpCd,
      brandCd: brandCd,
      manageDiv: "0",
      userId: user.userId
    };

    const { data: result } = await o2Api.getStoreWhere(params);
    const { responseBody, responseCode, responseMessage } = result;
    if (responseCode === "200") {
      if (responseBody != null) {
        // 성공
        setStore([{ storeCd: "", storeNm: "전체" }]);
        setStore((state) => state.concat(responseBody));
      }
    }
  };

  const getCorner = async (cmpCd, brandCd, storeCd) => {
    const params = {
      cmpCd: cmpCd,
      brandCd: brandCd,
      storeCd: storeCd
    };
    console.log(">>>>>> params : ", params);

    const { data: result } = await o2Api.getStoreCorner(params);
    const { responseBody, responseCode, responseMessage } = result;
    if (responseCode === "200") {
      if (responseBody != null) {
        // 성공
        setCorner([{ cornerCd: "", cornerNm: "전체" }]);
        setCorner((state) => state.concat(responseBody));
      }
    }
  };

  const handleSelect = (e, value) => {
    if (value === "C") {
      setBrand([{ brandCd: "", brandNm: "전체" }]);
      setSelected((state) => ({
        ...state,
        cmpCd: e.target.value
      }));
      getBrand(e.target.value);
    } else if (value === "B") {
      setSelected((state) => ({
        ...state,
        brandCd: e.target.value
      }));
      getStore(selected.cmpCd, selected.brandCd);
    } else if (value === "S") {
      console.log(">>>>>> store : ", e.target.value);
      setSelected((state) => ({
        ...state,
        storeCd: e.target.value
      }));
      getCorner(selected.cmpCd, selected.brandCd, e.target.value);
    } else if (value === "O") {
      setSelected((state) => ({
        ...state,
        cornerCd: e.target.value
      }));
    }
  };

  const search = async () => {
    // 조회 조건에 따라 분기
    setLoading(true);
    const { cmpCd, brandCd, storeCd, cornerCd } = selected;
    // cmpCd 는 필수
    if (brandCd.length > 0 && storeCd.length > 0 && cornerCd.length > 0) {
      // 코너 취급상품
      const params = {
        cmpCd: selected.cmpCd,
        brandCd: selected.brandCd,
        storeCd: selected.storeCd,
        cornerCd: selected.cornerCd,
        productNm: formData.productNm,
        restProductCd: formData.restProductCd,
        barcode: formData.barcode,
        isUse: formData.isUse
      };
      const { data: result } = await o2Api.getProductByCorner(params);
      const { responseBody, responseCode, responseMessage } = result;
      if (responseCode === "200") {
        if (responseBody != null) {
          setRowData(responseBody);
        }
      }
    } else if (brandCd.length > 0) {
      // 휴게소 취급상품
      const params = {
        cmpCd: selected.cmpCd,
        brandCd: selected.brandCd,
        productNm: formData.productNm,
        restProductCd: formData.restProductCd,
        barcode: formData.barcode,
        isUse: formData.isUse
      };
      const { data: result } = await o2Api.getProductByRest(params);
      const { responseBody, responseCode, responseMessage } = result;
      if (responseCode === "200") {
        if (responseBody != null) {
          setRowData(responseBody);
        }
      }
    } else {

    }
    setLoading(false);
  };

  const save = async () => {
    const { api } = gridRef.current;
    if (api === null) return;

    const selectRows = api.getSelectedRows();
    if (selectRows === 0) return;

    if (confirm("취급상품으로 등록하시겠습니까?")) {
      const { cmpCd, brandCd, storeCd, cornerCd } = selected;
      const params = [];
      // 코너취급
      if (brandCd.length > 0 && storeCd.length > 0 && cornerCd.length > 0) {
        selectRows.map((item) => {
          const data = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            cornerCd: cornerCd,
            productCd: item.productCd
          };
          params.push(data);
        });
        console.log("코너 params : ", params);
      } else if (brandCd.length > 0) {
        selectRows.map((item) => {
          const data = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            productCd: item.productCd
          };
          params.push(data);
        });
        console.log("휴게소 params : ", params);
      }

      const { data: result } = await o2Api.insertProductStore(params);
      const { responseBody, responseCode, responseMessage } = result;
      if (responseCode === "200") {
        if (responseBody != null) {
          search();
        }
      }
    }
  };

  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: 550, width: "100%" }), []);

  const onFirstDataRendered = useCallback((params) => {
    const { api } = gridRef.current;
    api.forEachNode((node) =>
      node.setSelected(node.data && node.data.isUse)
    );
  }, []);

  return (
    <div style={containerStyle}>
      <div className="d-grid gap-1 d-md-flex justify-content-between" style={{ marginBottom: 10 }}>
        <h5>취급상품 관리</h5>
        <div>
          <CButton style={{ marginRight: 10 }} color="dark" onClick={save}>등록</CButton>
          <CButton color="dark" onClick={search}>조회</CButton>
        </div>
      </div>
      <CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
        <CCol xs={12}>
          <CInputGroup size={"sm"} className={"mb-1"}>
            <CInputGroupText style={{ width: 80 }}>운영사</CInputGroupText>
            <CFormSelect id="company"
                         value={user.cmpCd ? user.cmpCd : selected.cmpCd}
                         onChange={(e) => handleSelect(e, "C")}>
              {company.map((cmp, index) => {
                return (
                  <option key={index} value={cmp.cmpCd}>{cmp.cmpNm}</option>
                );
              })}
            </CFormSelect>
          </CInputGroup>
        </CCol>
        <CCol xs={12}>
          <CInputGroup size={"sm"} className={"mb-1"}>
            <CInputGroupText style={{ width: 80 }}>휴게소</CInputGroupText>
            <CFormSelect id="brand"
                         value={user.brandCd ? user.brandCd : selected.brandCd}
                         onChange={(e) => handleSelect(e, "B")}>
              {brand.map((cmp, index) => {
                return (
                  <option key={index} value={cmp.brandCd}>{cmp.brandNm}</option>
                );
              })}
            </CFormSelect>
          </CInputGroup>
        </CCol>
        <CCol xs={12}>
          <CInputGroup size={"sm"} className={"mb-1"}>
            <CInputGroupText style={{ width: 80 }}>매장</CInputGroupText>
            <CFormSelect id="store"
                         value={user.storeCd ? user.storeCd : selected.storeCd}
                         onChange={(e) => handleSelect(e, "S")}>
              {store.map((item, index) => {
                return (
                  <option key={index} value={item.storeCd}>{item.storeNm}</option>
                );
              })}
            </CFormSelect>
          </CInputGroup>
        </CCol>
        <CCol xs={12}>
          <CInputGroup size={"sm"} className={"mb-1"}>
            <CInputGroupText style={{ width: 80 }}>코너</CInputGroupText>
            <CFormSelect id="brand"
                         value={selected.cornerCd}
                         onChange={(e) => handleSelect(e, "O")}>
              {corner.map((corner, index) => {
                return (
                  <option key={index} value={corner.cornerCd}>{corner.cornerNm}</option>
                );
              })}
            </CFormSelect>
          </CInputGroup>
        </CCol>
        <CCol xs={12}>
          <CInputGroup size={"sm"} className={"mb-1"}>
            <CInputGroupText style={{ width: 80 }}>상품코드</CInputGroupText>
            <CFormInput id="productCd"
                        style={{height: 35}}
                        onChange={(e) => {
                          setFormData((state) => ({
                            ...state,
                            restProductCd: e.target.value
                          }));
                        }}/>
          </CInputGroup>
        </CCol>
        <CCol xs={12}>
          <CInputGroup size={"sm"} className={"mb-1"}>
            <CInputGroupText style={{ width: 80 }}>상품명</CInputGroupText>
            <CFormInput id="productNm"
                        style={{height: 35}}
                        onChange={(e) => {
                          setFormData((state) => ({
                            ...state,
                            productNm: e.target.value
                          }));
                        }}/>
          </CInputGroup>
        </CCol>
        <CCol xs={12}>
          <CInputGroup size={"sm"} className={"mb-1"}>
            <CInputGroupText style={{ width: 80 }}>바코드</CInputGroupText>
            <CFormInput id="barcode"
                        style={{height: 35}}
                        onChange={(e) => {
                          setFormData((state) => ({
                            ...state,
                            barcode: e.target.value
                          }));
                        }}/>
          </CInputGroup>
        </CCol>
        <CCol xs={12}>
          <CInputGroup size={"sm"} className={"mb-1"}>
            <CInputGroupText style={{ width: 80 }}>사용유무</CInputGroupText>
            <CFormSelect onChange={(e) => {
              setFormData((state) => ({
                ...state,
                isUse: e.target.value
              }));
            }}>
              <option value={""}>전체상품</option>
              <option value={"Y"}>사용중</option>
            </CFormSelect>
          </CInputGroup>
        </CCol>
      </CForm>

      <div style={{ height: 10 }}/>
      <div className="ag-theme-alpine" style={gridStyle}>
        {loading ? <Loading/> : null}
        <AgGridReact
          ref={gridRef}
          onFirstDataRendered={onFirstDataRendered}
          rowMultiSelectWithClick={true}
          rowSelection={"multiple"}
          rowData={rowData}
          columnDefs={columnDefs}>
        </AgGridReact>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { account, store } = state;
  return {
    account, store
  };
};

export default connect(mapStateToProps, null)(HandleProduct);
